<!-- Container-fluid starts-->
<div class="container-fluid">

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body">

          <div class="row btn-showcase">
            <div class="col-lg-2 col-md-4 col-12">
              <div class="form-group">
                <label class="form-label">Publisher ID</label>
                <input type="number" min="0" class="form-control" placeholder="provide ID.." [(ngModel)]="blackListOffer.publisherId">
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-12">
              <div class="form-group">
                <label class="form-label">Advertiser</label>
                <ng-multiselect-dropdown
                [placeholder]="'-- advertiser --'"
                [settings]="dropdownSettingsAdvertiser"
                [data]="dropdownListAdvertiser"
                [(ngModel)]="selectedItemsAdvertiser"
                (onSelect)="onItemSelectAdvertiser($event)"
                (onSelectAll)="onSelectAllAdvertiser($event)"
                (onDeSelect)="onItemDeSelectType($event)"
                >
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-12">
              <div class="form-group">
                <label class="form-label">Advertiser offer ID</label>
                <input type="text" class="form-control" placeholder="provide ID.." [(ngModel)]="blackListOffer.advertiserOfferId" >
              </div>
            </div>
          </div>

          <div class="row btn-showcase">
            <div class="col-md-2">
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="add campaign on blacklist" (click)="onAdd()">
                <i class="fa fa-plus" aria-hidden="true"></i>Add</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
          <div class="card-header">
            <h5>All defined lists</h5>
          </div>
          <div class="card-body custom-datatable">
            <ngx-datatable
              class='bootstrap'  
              [rows]="blacklistData"            
              [columnMode]="ColumnMode.force"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [externalPaging]="true"
              [count]="page.totalElements"
              [offset]="page.pageNumber"
              [limit]="page.size"
              (page)="setPage($event)"
              [selected]="selected"
              [selectionType]="SelectionType.single"              
              (select)='onSelect($event)'>

              <ngx-datatable-column name="Date">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Date</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.date | date:'d/MM/yyyy H:mm'}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Publisher" prop="publisher.id">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Publisher ID</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row.publisher.id }} <small>({{ row.publisher.username }})</small>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Advertiser" prop="advertiser.name">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.advertiser.name}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="campaignid" prop="offer.advertiserOfferId">
                <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                  <span class="myHeader txt-primary" (click)="sort()">Advertise offer ID</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.offer.advertiserOfferId}}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <div class="btn-showcase">
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="remove selected campaign" (click)="onDelete()">
                Delete</button>
            </div>
          </div>
      </div>
    </div>

  </div>
</div>
<!-- Container-fluid Ends-->
